import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import InputField from "../../components/inputs/inputField";
import cityTimezones from "city-timezones";
import API from "../../utils/API";
import TimeField from "../../components/inputs/timeField";
import SelectField from "../../components/inputs/selectField";
import SectionHeader from "../../components/views/SectionHeader";
import SectionFooter from "../../components/views/SectionFooter";
import ViewSubmissionModal from "./modals/viewSubmissionModal";


class RequestDetails extends Component {
  constructor(props) {
    super(props);

    const {
      match: { params },
      program,
      organization,
    } = this.props;
    const request = props.requests.find((r) => r._id == params.requestId);
    let parsedAdditionalAttendees = [];
    if (request.additionalAttendees) {
      if (Array.isArray(request.additionalAttendees)) {
        parsedAdditionalAttendees = request.additionalAttendees;
      } else if (typeof request.additionalAttendees === "string") {
        try {
          const parsed = JSON.parse(request.additionalAttendees);
          parsedAdditionalAttendees = parsed;
        } catch (error) {
          parsedAdditionalAttendees = [];
        }
      }
    }
    // Custom attendee questions are saved as "_attendee" + propertyName,
    // but labeled by the question's id. Map propertyName -> question id.
    const attendeePropertyToField = {};
    const requestForm = request.requestForm || program.requestForm;
    (requestForm?.pages || []).forEach((page) =>
      (page.sections || []).forEach((section) =>
        (section.fields || []).forEach((field) => {
          if (field.type !== "additionalAttendees") return;
          (field.moduleConfiguration?.fields || []).forEach((question) => {
            const propertyName = question.attendeeField?.propertyName;
            if (propertyName && question.id) {
              attendeePropertyToField[propertyName] = question.id;
            }
          });
        })
      )
    );
    const additionalAttendees = parsedAdditionalAttendees.map((attendee) =>
      Object.fromEntries(
        Object.entries(attendee).map(([key, value]) => {
          if (key.startsWith('_attendee')) {
            const stripped = key.slice('_attendee'.length); // e.g. "City"
            const normalized = stripped.charAt(0).toLowerCase() + stripped.slice(1); // "city"
            return [attendeePropertyToField[normalized] || normalized, value];
          }
          return [key, value];
        })
      )
    );
    this.props.setActiveRow(params.requestId)

    const requiredFields = {
      name: false,
      startDate: false,
      endDate: false,
      startTime: false,
      endTime: false,
      timezone: false,
    };
    const eventDefaultDetails = program.eventDefaults.details;
    program.eventCustomFields &&
      program.eventCustomFields.forEach((category) => {
        category.fields.map((field) => {
          if (
            eventDefaultDetails.requiredCustomFields &&
            eventDefaultDetails.requiredCustomFields.includes(field._id)
          ) {
            requiredFields[field._id] = false;
          }
        });
      });

    // Salesforce integration setup - merge organization and program defaults
    let customFields = [];
    const salesforceIntegration = organization.integrations.find((integration) => integration.identifier == 'salesforce');
    const programSalesforce = program.eventDefaults?.details?.integrations?.salesforce;
    const programSalesforceDefaults = programSalesforce?.customFields;

    // Start with organization fields
    if (salesforceIntegration) {
      customFields = [...(salesforceIntegration.customFields || [])];
    }

    // Merge program fields (override or add)
    if (programSalesforceDefaults && programSalesforceDefaults.length > 0) {
      programSalesforceDefaults.forEach(programField => {
        const existingIndex = customFields.findIndex(f => f.id === programField.id);
        if (existingIndex >= 0) {
          customFields[existingIndex] = programField;  // Override
        } else {
          customFields.push(programField);  // Add
        }
      });
    }

    // Load customFields from existing request
    let requestCustomFields = [];
    customFields.forEach((field) => {
      const existingField = request.integrations?.salesforce?.customFields?.find(f => f.id === field.id);
      if (existingField) {
        const fieldWithValue = {
          ...field,
          value: existingField.value || '',
          displayValue: existingField.displayValue || '',
        };
        // Only add nestedValues for nestedSection type fields
        if (field.type === 'nestedSection') {
          fieldWithValue.nestedValues = existingField.nestedValues || {};
        }
        requestCustomFields.push(fieldWithValue);
      } else {
        const fieldWithValue = {
          ...field,
          value: field.value || '', // Use program's default value if available
          displayValue: '',
        };
        // Only add nestedValues for nestedSection type fields
        if (field.type === 'nestedSection') {
          fieldWithValue.nestedValues = field.nestedValues || {};
        }
        requestCustomFields.push(fieldWithValue);
      }
    });

    // Set search values for existing displayValues
    let contactSearchValues = {};
    let accountSearchValues = {};
    let visibleSfContactSearches = 1;
    let visibleSfAccountSearches = 1;

    requestCustomFields.forEach((field) => {
      if (field.type === 'sfcontactsearch' && field.displayValue) {
        contactSearchValues[0] = field.displayValue;
        visibleSfContactSearches = 1;
      } else if (field.type === 'sfaccountsearch' && field.displayValue) {
        accountSearchValues[0] = field.displayValue;
        visibleSfAccountSearches = 1;
      }
    });

    let sfCredentials = {};
    let sfToken = '';
    if (salesforceIntegration && salesforceIntegration.credentials) {
      sfCredentials = salesforceIntegration.credentials;
      sfToken = sfCredentials.token || '';
    }
    this.state = {
      editing: false,
      loading: false,
      request: request,
      submitting: false,
      cityLookup: "",
      editedRequest: { ...request },
      additionalAttendees: additionalAttendees,
      requiredFields: requiredFields,
      campaignNameErrorTrigger: false,
      salesforceEnabled: program.eventDefaults?.details?.salesforceEnabled || false,
      customFields: requestCustomFields,
      // Salesforce lookup states
      sfCredentials: sfCredentials,
      sfToken: sfToken,
      selectedAccounts: {},
      accountSearchValues: accountSearchValues,
      accountSearchResults: {},
      accountSearching: {},
      selectedContacts: {},
      contactSearchValues: contactSearchValues,
      contactSearchResults: {},
      contactSearching: {},
      visibleSfContactSearches: visibleSfContactSearches,
      visibleSfAccountSearches: visibleSfAccountSearches,
      submissionModalOpen: false,
    };
  }

  toggleSubmissionModal = () => {
    this.setState((prevState) => ({
      submissionModalOpen: !prevState.submissionModalOpen,
    }));
  };

  downloadSubmissionCSV = () => {
    const { request, additionalAttendees } = this.state;
    const { program } = this.props;
    const eventDefaultDetails = program.eventDefaults?.details || {};

    const escapeCSV = (val) => {
      if (val === null || val === undefined) return '';
      const str = String(val);
      if (str.includes(',') || str.includes('"') || str.includes('\n')) {
        return `"${str.replace(/"/g, '""')}"`;
      }
      return str;
    };

    const rows = [['Property', 'Value']];

    // Core fields
    rows.push(['Submitter Name', request.submitterName || '']);
    rows.push(['Submitter Email', request.submitterEmail || '']);
    rows.push(['Requested Event Name', request.name || '']);
    rows.push(['Start Date', request.startDate || '']);
    rows.push(['End Date', request.endDate || '']);
    rows.push(['Start Time', request.startTime || '']);
    rows.push(['End Time', request.endTime || '']);
    rows.push(['Timezone', request.timezone || '']);
    if (request.availabilityCalendar) {
      rows.push(['Requested Calendar', request.availabilityCalendar]);
    }

    // Required custom fields
    if (program.eventCustomFields) {
      const requiredCustomFields = eventDefaultDetails.requiredCustomFields || [];
      program.eventCustomFields.forEach((category) => {
        category.fields.forEach((field) => {
          if (
            requiredCustomFields.includes(field._id) &&
            request[field._id] &&
            request[field._id] !== ''
          ) {
            rows.push([field.fieldName, request[field._id]]);
          }
        });
      });
    }

    // Additional program fields (fieldLabels)
    if (program.fieldLabels) {
      Object.keys(program.fieldLabels).forEach((field) => {
        if (request[field] && request[field] !== '') {
          rows.push([program.fieldLabels[field], request[field]]);
        }
      });
    }

    // Additional attendees
    if (additionalAttendees && additionalAttendees.length > 0) {
      additionalAttendees.forEach((attendee, i) => {
        rows.push([`Additional Attendee ${i + 1}`, '']);
        if (program.attendeeFieldLabels) {
          Object.keys(program.attendeeFieldLabels).forEach((field) => {
            if (attendee[field] !== undefined && attendee[field] !== '') {
              rows.push([`  ${program.attendeeFieldLabels[field]}`, attendee[field]]);
            }
          });
        }
      });
    }

    // Salesforce additional attendees
    const salesforceAdditionalAttendees =
      request.integrations?.salesforce?.additionalAttendees || [];
    if (salesforceAdditionalAttendees.length > 0) {
      salesforceAdditionalAttendees.forEach((attendee, i) => {
        rows.push([`Salesforce Attendee ${i + 1}`, `${attendee.FirstName || ''} ${attendee.LastName || ''}`.trim()]);
      });
    }

    // Salesforce custom fields
    const salesforceCustomFields = (
      request.integrations?.salesforce?.customFields || []
    ).filter((field) => field.value && field.value !== '');
    if (salesforceCustomFields.length > 0) {
      salesforceCustomFields.forEach((field, index) => {
        rows.push([field.label || `Salesforce Field ${index + 1}`, field.displayValue || field.value]);
      });
    }

    const csvContent = rows
      .map((row) => row.map(escapeCSV).join(','))
      .join('\n');

    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    const safeName = (request.name || 'submission').replace(/[^a-z0-9]/gi, '-').toLowerCase();
    link.href = url;
    link.setAttribute('download', `request-submission-${safeName}.csv`);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
  };


  componentDidMount() {
    const { match: { params } } = this.props;

    this.props.setActiveRow(params.requestId);
  }
  componentWillUnmount() {
    this.props.setActiveRow(null);
    if (this.accountSearchTimeout) {
      clearTimeout(this.accountSearchTimeout);
    }
    if (this.contactSearchTimeout) {
      clearTimeout(this.contactSearchTimeout);
    }
  }

  refreshToken = async () => {
    try {
      const orgId = this.props.organization._id;
      const response = await API().get(`Organizations/${orgId}/integrate/salesforce/refreshAdmin`);
      if (response.data && response.data.token) {
        this.setState({ sfToken: response.data.token });
        return response.data.token;
      }
    } catch (error) {
      console.error('Error refreshing token:', error);
    }
    return null;
  }

  searchAccounts = async (value, fieldIndex) => {
    const { sfCredentials, sfToken } = this.state;
    const instanceUrl = sfCredentials.instance_url;
    if (!instanceUrl || !sfToken) return;
    this.setState(prevState => ({
      accountSearching: {
        ...prevState.accountSearching,
        [fieldIndex]: true
      }
    }));

    try {
      const response = await fetch(`${instanceUrl}/services/data/v59.0/parameterizedSearch/?q=${value}&sobject=Account&Account.fields=AccountNumber,Name,BillingCity,BillingState,BillingPostalCode&Account.limit=100`, {
        headers: {
          'Authorization': `Bearer ${sfToken}`,
          'Content-Type': 'application/json'
        }
      });

      if (response.status === 401) {
        const newToken = await this.refreshToken();
        if (newToken) {
          return this.searchAccounts(value, fieldIndex);
        }
        return;
      }

      if (response.ok) {
        const data = await response.json();
        this.setState(prevState => ({
          accountSearchResults: {
            ...prevState.accountSearchResults,
            [fieldIndex]: data.searchRecords || []
          },
          accountSearching: {
            ...prevState.accountSearching,
            [fieldIndex]: false
          }
        }));
      } else {
        this.setState(prevState => ({
          accountSearching: {
            ...prevState.accountSearching,
            [fieldIndex]: false
          }
        }));
      }
    } catch (error) {
      console.error('Error searching accounts:', error);
      this.setState(prevState => ({
        accountSearching: {
          ...prevState.accountSearching,
          [fieldIndex]: false
        }
      }));
    }
  }

  triggerAccountSearch = (value, fieldIndex) => {
    if (this.accountSearchTimeouts && this.accountSearchTimeouts[fieldIndex]) {
      clearTimeout(this.accountSearchTimeouts[fieldIndex]);
    }
    this.setState(prevState => ({
      accountSearchValues: {
        ...prevState.accountSearchValues,
        [fieldIndex]: value
      }
    }));

    if (value.length === 0) {
      this.setState(prevState => ({
        accountSearchResults: {
          ...prevState.accountSearchResults,
          [fieldIndex]: []
        }
      }));
      return;
    }

    if (value.length < 3) return;

    if (!this.accountSearchTimeouts) {
      this.accountSearchTimeouts = {};
    }
    this.accountSearchTimeouts[fieldIndex] = setTimeout(() => {
      this.searchAccounts(value, fieldIndex);
    }, 500);
  }

  selectAccount = (account, fieldIndex) => {
    this.setState(prevState => ({
      selectedAccounts: {
        ...prevState.selectedAccounts,
        [fieldIndex]: account
      },
      accountSearchResults: {
        ...prevState.accountSearchResults,
        [fieldIndex]: []
      },
      accountSearchValues: {
        ...prevState.accountSearchValues,
        [fieldIndex]: account.Name
      }
    }));
  }

  clearAccount = (fieldIndex) => {
    this.setState(prevState => ({
      selectedAccounts: {
        ...prevState.selectedAccounts,
        [fieldIndex]: null
      },
      accountSearchValues: {
        ...prevState.accountSearchValues,
        [fieldIndex]: ''
      },
      accountSearchResults: {
        ...prevState.accountSearchResults,
        [fieldIndex]: []
      }
    }));
  }

  searchContacts = async (value, fieldIndex) => {
    const { sfCredentials, sfToken } = this.state;
    const instanceUrl = sfCredentials.instance_url;

    if (!instanceUrl || !sfToken) return;

    this.setState(prevState => ({
      contactSearching: {
        ...prevState.contactSearching,
        [fieldIndex]: true
      }
    }));

    try {
      const response = await fetch(`${instanceUrl}/services/data/v59.0/parameterizedSearch/?q=${value}&sobject=Contact&Contact.fields=id,Email,FirstName,LastName,MailingAddress,MailingCity,MailingState,MailingPostalCode&Contact.limit=100`, {
        headers: {
          'Authorization': `Bearer ${sfToken}`,
          'Content-Type': 'application/json'
        }
      });

      if (response.status === 401) {
        const newToken = await this.refreshToken();
        if (newToken) {
          return this.searchContacts(value, fieldIndex);
        }
        return;
      }

      if (response.ok) {
        const data = await response.json();
        this.setState(prevState => ({
          contactSearchResults: {
            ...prevState.contactSearchResults,
            [fieldIndex]: data.searchRecords || []
          },
          contactSearching: {
            ...prevState.contactSearching,
            [fieldIndex]: false
          }
        }));
      } else {
        this.setState(prevState => ({
          contactSearching: {
            ...prevState.contactSearching,
            [fieldIndex]: false
          }
        }));
      }
    } catch (error) {
      console.error('Error searching contacts:', error);
      this.setState(prevState => ({
        contactSearching: {
          ...prevState.contactSearching,
          [fieldIndex]: false
        }
      }));
    }
  }

  triggerContactSearch = (value, fieldIndex) => {
    if (this.contactSearchTimeouts && this.contactSearchTimeouts[fieldIndex]) {
      clearTimeout(this.contactSearchTimeouts[fieldIndex]);
    }
    this.setState(prevState => ({
      contactSearchValues: {
        ...prevState.contactSearchValues,
        [fieldIndex]: value
      }
    }));

    if (value.length === 0) {
      this.setState(prevState => ({
        contactSearchResults: {
          ...prevState.contactSearchResults,
          [fieldIndex]: []
        }
      }));
      return;
    }

    if (value.length < 3) return;

    if (!this.contactSearchTimeouts) {
      this.contactSearchTimeouts = {};
    }
    this.contactSearchTimeouts[fieldIndex] = setTimeout(() => {
      this.searchContacts(value, fieldIndex);
    }, 300);
  }

  selectContact = (contact, fieldIndex) => {
    this.setState(prevState => ({
      selectedContacts: {
        ...prevState.selectedContacts,
        [fieldIndex]: contact
      },
      contactSearchResults: {
        ...prevState.contactSearchResults,
        [fieldIndex]: []
      },
      contactSearchValues: {
        ...prevState.contactSearchValues,
        [fieldIndex]: `${contact.FirstName || ''} ${contact.LastName}`.trim()
      }
    }));
  }

  clearContact = (fieldIndex) => {
    this.setState(prevState => ({
      selectedContacts: {
        ...prevState.selectedContacts,
        [fieldIndex]: null
      },
      contactSearchValues: {
        ...prevState.contactSearchValues,
        [fieldIndex]: ''
      },
      contactSearchResults: {
        ...prevState.contactSearchResults,
        [fieldIndex]: []
      }
    }));
  }

  approveRequest = () => {
    const { editedRequest, editing } = this.state;
    const requiredFields = this.state.requiredFields;
    let valid = true;
    Object.keys(requiredFields).forEach((key) => {
      if (!editedRequest[key] || editedRequest[key] === "") {
        requiredFields[key] = true;
        valid = false;
      } else {
        requiredFields[key] = false;
      }
    });
    let campaignNameErrorTrigger = false;
    //check for salesforce campaign name
    if (this.state.salesforceEnabled && (!editedRequest.integrations?.salesforce?.campaignName || editedRequest.integrations.salesforce.campaignName === '')) {
      campaignNameErrorTrigger = true;
      valid = false;
    } else {
      campaignNameErrorTrigger = false;
    }

    // Validate required customFields
    if (this.state.salesforceEnabled && this.state.customFields) {
      this.state.customFields.forEach((field) => {
        if (field.required && (!field.value || field.value === '')) {
          valid = false;
        }
      });
    }

    if (valid && !editing) {
      this.setState({ submitting: true });
      API()
        .post(
          `Organizations/${this.props.orgId}/programs/${this.props.program._id}/requests/${this.state.request._id}/approve`,
          editedRequest
        )
        .then((res) => {
          if (res.data.success) {
            window.open(
              `/${this.props.orgId}/events/${res.data.event._id}/overview`,
              "_self"
            );
          }
        })
        .catch((err) => {
          console.log(err);
        });
    } else {
      this.setState({ requiredFields: requiredFields, campaignNameErrorTrigger: campaignNameErrorTrigger });
    }
  };

  denyRequest = () => {
    const { request, editedRequest, editing } = this.state;
    if (!editing) {
      this.setState({ submitting: true });
      API()
        .post(
          `Organizations/${this.props.orgId}/programs/${this.props.program._id}/requests/${this.state.request._id}/deny`,
          editedRequest
        )
        .then((res) => {
          const r = { ...request };
          const r2 = { ...editedRequest };
          r.status = "denied";
          r2.status = "denied";

          this.props.saveRequest(r, () => {
            this.setState({
              request: r,
              editedRequest: r2,
            });
          });
        })
        .catch((err) => {
          console.log(err);
        });
    }
  };

  reviewRequest = () => {
    const { request, editedRequest, editing } = this.state;
    if (!editing) {
      this.setState({ submitting: true });
      API()
        .post(
          `Organizations/${this.props.orgId}/programs/${this.props.program._id}/requests/${this.state.request._id}/review`
        )
        .then((res) => {
          if (res.data && res.data.success) {
            const r = { ...request };
            const r2 = { ...editedRequest };
            r.status = "review";
            r2.status = "review";

            this.props.updateRequestStatus(r, () => {
              this.setState({
                request: r,
                editedRequest: r2,
                submitting: false,
              });
            });
          } else {
            this.setState({ submitting: false });
          }
        })
        .catch((err) => {
          console.log(err);
          this.setState({ submitting: false });
        });
    }
  };

  saveRequest = () => {
    const { editedRequest, requiredFields, customFields } = this.state;
    let valid = true;
    Object.keys(requiredFields).forEach((key) => {
      if (!editedRequest[key] || editedRequest[key] === "") {
        requiredFields[key] = true;
        valid = false;
      } else requiredFields[key] = false;
    });

    if (valid) {
      // Save customFields to integrations.salesforce.customFields
      if (this.state.salesforceEnabled && customFields) {
        editedRequest.integrations = editedRequest.integrations || { salesforce: {} };
        editedRequest.integrations.salesforce = editedRequest.integrations.salesforce || {};
        editedRequest.integrations.salesforce.customFields = customFields;
      }

      this.props.saveRequest(editedRequest, () => {
        this.setState({
          request: { ...editedRequest },
          editing: false,
          requiredFields: requiredFields,
        });
      });
    } else {
      this.setState({ requiredFields: requiredFields });
    }
  };

  checkFormValidity = () => {
    const { editedRequest, requiredFields, customFields, salesforceEnabled } = this.state;

    // Check standard required fields
    if (!editedRequest.name || !editedRequest.startDate || !editedRequest.endDate || !editedRequest.startTime || !editedRequest.endTime || !editedRequest.timezone) {
      return false;
    }

    // Check required custom fields (error triggers)
    for (let key in requiredFields) {
      if (requiredFields[key]) return false;
    }

    // Check salesforce custom fields required
    if (salesforceEnabled && customFields) {
      for (let field of customFields) {
        if (field.required && (!field.value || field.value === '')) {
          return false;
        }
      }
    }

    // Check campaign name if salesforce enabled
    if (salesforceEnabled && (!editedRequest.integrations?.salesforce?.campaignName || editedRequest.integrations.salesforce.campaignName === '')) {
      return false;
    }

    return true;
  };

  cancelEdit = () => {
    const request = JSON.parse(JSON.stringify(this.state.request));
    console.log(request);
    const requiredFields = this.state.requiredFields;
    Object.keys(requiredFields).forEach((key) => {
      requiredFields[key] = false;
    });
    this.setState({
      editedRequest: { ...request },
      requiredFields: requiredFields,
      editing: false,
    });
  };

  displaySalesforceAdditionalAttendees = () => {
    const { editedRequest } = this.state;

    let salesforceAdditionalAttendees = editedRequest.integrations && editedRequest.integrations.salesforce && editedRequest.integrations.salesforce.additionalAttendees ? editedRequest.integrations.salesforce.additionalAttendees : [];

    return (<>
      {salesforceAdditionalAttendees.length > 0 && (
        <div className="sectionBlock">
          <h2 className="blockHeader">Salesforce Additional Attendees</h2>
          {salesforceAdditionalAttendees.map((attendee, i) => {
            console.log(attendee);
            let attendeeName = `${attendee.FirstName} ${attendee.LastName}`;
            return (
              <div className="addtionalAttendeeContainer w-100">
                <InputField
                  label={'Salesforce attendee name'}
                  type="text"
                  value={attendeeName}
                  disabled={true}
                  inputIcon={<i className="las la-lock lightGray" />}
                />
              </div>
            );
          })}
        </div>
      )}
    </>)
  }

  render() {
    const {
      editing,
      request,
      editedRequest,
      requiredFields,
      cityLookup,
      submitting,
    } = this.state;
    const { program } = this.props;
    const eventDefaultDetails = program.eventDefaults.details;

    const cityTimezoneOptions =
      cityLookup != ""
        ? cityTimezones.findFromCityStateProvince(cityLookup).map((tz) => {
          return { label: `${tz.city}, ${tz.province}`, value: tz.timezone };
        })
        : [];
    return (
      <div className="sectionContainer">
        <SectionHeader
          title={"Request Form"}
          description={`${!this.checkFormValidity()
            ? "Required fields are missing, please fill out and save to approve"
            : request.status == "pending"
              ? "Request is pending, approve it to create event"
              : request.status == "review"
                ? "Request is in review, approve it to create event"
                : request.status == "denied"
                  ? "Request was denied"
                  : "Request was approved"
            }`}
          mainActions={
            request.status == "denied"
              ? [
                {
                  type: "button",
                  label: "Approve",
                  onClick: this.approveRequest,
                },
              ]
              : !request.eventId
                ? [
                  {
                    type: "button",
                    label: submitting ? "Approving" : "Approve",
                    disabled: submitting || !this.checkFormValidity(),
                    onClick: this.approveRequest,
                  },
                  ...(request.status == "pending"
                    ? [{ type: "button", label: "Review", onClick: this.reviewRequest }]
                    : []),
                  { type: "button", label: "Deny", onClick: this.denyRequest },
                ]
                : [
                  {
                    type: "link",
                    label: "View event",
                    target: `/${this.props.orgId}/events/${request.eventId}/overview`,
                  },
                ]
          }
          closeButton={true}
          additionalActions={[
            <div style={{ display: 'flex', justifyContent: 'flex-start', width: '100%' }}>
              <button
                className="outline mr-10"
                onClick={this.toggleSubmissionModal}
              >
                View Submission
              </button>
            </div>,
          ]}
          subActions={[
            {
              label: 'Download Submission',
              iconClass: 'las la-download',
              onClick: this.downloadSubmissionCSV,
            },
          ]}



        /*  breadcrumbs={[
           {
             name: program.name,
           },
           {
             name: "Requests",
           },
           {
             name: request.name,
           },
         ]} */
        />
        {this.state.submissionModalOpen && (
          <ViewSubmissionModal
            isOpen={this.state.submissionModalOpen}
            toggle={this.toggleSubmissionModal}
            request={this.state.request}
            program={program}
          />
        )}

        <div className="sectionBody">
          <div className="sectionBlock">
            <h2 className="blockHeader">Request Details</h2>
            <InputField
              label="Submitter Name"
              value={editedRequest.submitterName}
              disabled={true}
              inputIcon={<i className="las la-lock" />}
            />
            <InputField
              label="Submitter Email"
              value={editedRequest.submitterEmail}
              disabled={true}
              inputIcon={<i className="las la-lock" />}
            />
            <InputField
              label="Requested Event Name"
              value={editedRequest.name}
              required={true}
              errorTrigger={requiredFields.name}
              disabled={!!request.eventId}
              onChange={(e) => {
                const r = { ...editedRequest };
                r.name = e.target.value;
                this.setState({
                  editedRequest: r,
                  editing: true,
                });
              }}
              inputIcon={
                !!request.eventId ? <i className="las la-lock" /> : false
              }
            />
            <div className="flex-sb w-100">
              <InputField
                label="Start Date"
                type="date"
                classes="mr-10"
                required={true}
                errorTrigger={requiredFields.startDate}
                value={editedRequest.startDate}
                disabled={!!request.eventId}
                onChange={(e) => {
                  const r = { ...editedRequest };
                  r.startDate = e.target.value;
                  this.setState({
                    editedRequest: r,
                    editing: true,
                  });
                }}
                inputIcon={
                  !!request.eventId ? (
                    <i className="las la-lock" />
                  ) : (
                    <i className="las la-calendar" />
                  )
                }
              />
              <InputField
                label="End Date"
                type="date"
                value={editedRequest.endDate}
                required={true}
                errorTrigger={requiredFields.endDate}
                disabled={!!request.eventId}
                classes="ml-10"
                onChange={(e) => {
                  const r = { ...editedRequest };
                  r.endDate = e.target.value;
                  this.setState({
                    editedRequest: r,
                    editing: true,
                  });
                }}
                inputIcon={
                  !!request.eventId ? (
                    <i className="las la-lock" />
                  ) : (
                    <i className="las la-calendar" />
                  )
                }
              />
            </div>
            <div className="flex-sb w-100">
              <TimeField
                label={"Start Time"}
                onChange={(time) => {
                  const r = { ...editedRequest };
                  r.startTime = time;
                  this.setState({
                    editedRequest: r,
                    editing: true,
                  });
                }}
                required={true}
                errorTrigger={requiredFields.startTime}
                disabled={!!request.eventId}
                value={editedRequest.startTime}
                classes="mr-10 w-100"
                iconClass={
                  !!request.eventId ? (
                    "las la-lock"
                  ) : (
                    "las la-calendar"
                  )
                }
              />
              <TimeField
                label={"End Time"}
                onChange={(time) => {
                  const r = { ...editedRequest };
                  r.endTime = time;
                  this.setState({
                    editedRequest: r,
                    editing: true,
                  });
                }}
                required={true}
                errorTrigger={requiredFields.endTime}
                disabled={!!request.eventId}
                value={editedRequest.endTime}
                classes="ml-10 w-100"
                iconClass={
                  !!request.eventId ? (
                    "las la-lock"
                  ) : (
                    "las la-calendar"
                  )
                }
              />
            </div>

            <SelectField
              label="Timezone"
              value={{
                value: editedRequest.timezone,
                label: editedRequest.timezone,
              }}
              name="registrationPageSlug"
              options={cityTimezoneOptions}
              required={true}
              errorTrigger={requiredFields.timezone}
              disabled={!!request.eventId}
              onInputChange={(text) => {
                this.setState({ cityLookup: text });
              }}
              noOptionsMessage={({ inputValue }) =>
                !inputValue
                  ? "Type city name to get options"
                  : "No cities match your search"
              }
              onChange={(timezone) => {
                this.setState({
                  editedRequest: { ...editedRequest, timezone: timezone.value },
                  editing: true,
                });
              }}
            />

            <InputField
              label="Requested Calendar"
              value={editedRequest.availabilityCalendar}
              disabled={true}
              inputIcon={<i className="las la-lock" />}
            />
            {eventDefaultDetails.requiredCustomFields.length > 0 && (
              <h2 className="blockHeader">Required Custom Fields</h2>
            )}
            {program.eventCustomFields &&
              program.eventCustomFields.map((category, i) => {
                let fields = category.fields.map((field, j) => {
                  if (
                    eventDefaultDetails.requiredCustomFields &&
                    eventDefaultDetails.requiredCustomFields.includes(field._id)
                  ) {
                    return (
                      <div
                        className="flex-ac flex-sb"
                        key={`customField-${i}-${j}`}
                      >
                        <InputField
                          label={`${field.fieldName}`}
                          type={field.fieldType}
                          required={
                            eventDefaultDetails.requiredCustomFields &&
                            eventDefaultDetails.requiredCustomFields.includes(
                              field._id
                            )
                          }
                          errorTrigger={requiredFields[field._id]}
                          value={
                            editedRequest[field._id]
                              ? editedRequest[field._id]
                              : field.fieldValue
                          }
                          disabled={!!request.eventId}
                          onChange={(e) => {
                            const r = { ...editedRequest };
                            r[field._id] = e.target.value;
                            this.setState({
                              editedRequest: r,
                              editing: true,
                            });
                          }}
                          inputIcon={
                            !!request.eventId && (
                              <i className="las la-lock lightGray" />
                            )
                          }
                        />
                      </div>
                    );
                  }
                });
                //check if fields is empty
                fields = fields.filter(function (el) {
                  return el;
                });

                if (fields.length > 0) {
                  return (
                    <div className="sectionBlock" key={`customField-${i}`}>
                      <h2 className="blockHeader">{category.title}</h2>
                      {fields}
                    </div>
                  );
                }
              })}
            {program.fieldLabels &&
              Object.keys(program.fieldLabels).map((field, i) => {
                if (!eventDefaultDetails.requiredCustomFields.includes(field)) {
                  return (
                    <InputField
                      label={program.fieldLabels[field]}
                      type="text"
                      value={editedRequest[field]}
                      disabled={!!request.eventId}
                      onChange={(e) => {
                        const r = { ...editedRequest };
                        r[field] = e.target.value;
                        this.setState({
                          editedRequest: r,
                          editing: true,
                        });
                      }}
                      inputIcon={
                        !!request.eventId && (
                          <i className="las la-lock lightGray" />
                        )
                      }
                    />
                  );
                }
              })}
          </div>
          {this.state.additionalAttendees.length > 0 && (
            <div className="sectionBlock">
              <h2 className="blockHeader">Additional Attendees</h2>
              {this.state.additionalAttendees.map((attendee, i) => {
                return (
                  <div className="addtionalAttendeeContainer w-100">
                    {program.attendeeFieldLabels &&
                      Object.keys(program.attendeeFieldLabels).map((field) => {
                        console.log({ attendeeFieldLabels: program.attendeeFieldLabels, field, attendee });

                        return (
                          <InputField
                            label={program.attendeeFieldLabels[field]}
                            type="text"
                            value={attendee[field]}
                            disabled={true}
                            inputIcon={<i className="las la-lock lightGray" />}
                          />
                        );
                      })}
                  </div>
                );
              })}
            </div>
          )}


          {editedRequest.integrations && editedRequest.integrations.salesforce && editedRequest.integrations.salesforce.accountName &&
            <div className="sectionBlock">
              <h2 className="blockHeader">Salesforce Account Name</h2>
              <InputField
                label="Salesforce Account Name"
                value={editedRequest.integrations && editedRequest.integrations.salesforce && editedRequest.integrations.salesforce.accountName ? editedRequest.integrations.salesforce.accountName : ""}
                disabled={true}
                inputIcon={<i className="las la-lock lightGray" />}
              />
            </div>
          }
          {this.state.salesforceEnabled && (
            <div className="sectionBlock">
              <h2 className="blockHeader">Salesforce Campaign Name</h2>
              <InputField
                label="Campaign Name"
                value={editedRequest.integrations?.salesforce?.campaignName || ""}
                required={true}
                errorTrigger={this.state.campaignNameErrorTrigger}
                disabled={false}
                onChange={(e) => {
                  const r = { ...editedRequest };
                  if (!r.integrations) r.integrations = {};
                  if (!r.integrations.salesforce) r.integrations.salesforce = {};
                  r.integrations.salesforce.campaignName = e.target.value;
                  this.setState({
                    editedRequest: r,
                    editing: true,
                  });
                }}
              />
            </div>
          )}
          {this.displaySalesforceAdditionalAttendees()}

          {this.state.salesforceEnabled && this.state.customFields && this.state.customFields.length > 0 && (
            <div className="sectionBlock">
              <h2 className="blockHeader">Salesforce Custom Fields</h2>
              <p className='small gray mb-10'>Configure Salesforce integration settings for this request.</p>
              {(() => {
                const sfContactSearchIndices = this.state.customFields.map((field, index) => field.type === 'sfcontactsearch' ? index : -1).filter(idx => idx !== -1);
                const visibleSfContactSearchCount = Math.min(this.state.visibleSfContactSearches || 1, sfContactSearchIndices.length);
                return (<>
                  {this.state.customFields.map((field, index) => {
                    if (field.type === 'select') {
                      let processedOptions = field.options || [];
                      // Handle options that may not have value property (use label as value)
                      processedOptions = processedOptions.map(opt => ({
                        value: opt.value || opt.label,
                        label: opt.label
                      }));
                      return (
                        <SelectField
                          key={index}
                          label={field.label || `Field ${index + 1}`}
                          required={field.required}
                          value={field.value ? { value: field.value, label: field.options?.find(opt => opt.value === field.value)?.label || field.value } : null}
                          options={processedOptions}
                          onChange={(selectedOption) => {
                            console.log({ selectedOption })
                            const updatedCustomFields = [...this.state.customFields];
                            updatedCustomFields[index].value = selectedOption ? selectedOption.value : '';
                            this.setState({ customFields: updatedCustomFields }, this.validateForm);
                          }}
                        />
                      );
                    } else if (field.type === 'nestedSection') {
                      const selectedOptionLabel = field.options?.find(opt => opt.value === field.value)?.label || field.value;
                      const triggeredFields = field.triggerOptions?.[selectedOptionLabel] || [];
                      let processedOptions = field.options || [];
                      // Handle options that may not have value property (use label as value)
                      processedOptions = processedOptions.map(opt => ({
                        value: opt.value || opt.label,
                        label: opt.label
                      }));
                      return (
                        <div key={index}>
                          <SelectField
                            label={field.label || `Field ${index + 1}`}
                            required={field.required}
                            value={field.value ? { value: field.value, label: selectedOptionLabel } : null}
                            options={processedOptions}
                            onChange={(selectedOption) => {
                              const updatedCustomFields = [...this.state.customFields];
                              updatedCustomFields[index].value = selectedOption ? selectedOption.value : '';
                              // Clear nested values when main selection changes
                              if (updatedCustomFields[index].nestedValues) {
                                updatedCustomFields[index].nestedValues = {};
                              }
                              this.setState({ customFields: updatedCustomFields }, this.validateForm);
                            }}
                          />
                          {field.value && triggeredFields.map((triggerField, triggerIndex) => {
                            const nestedValue = field.nestedValues?.[triggerField.id] || '';
                            if (triggerField.type === 'select') {
                              // Handle options that may not have value property (use label as value)
                              const processedOptions = (triggerField.options || []).map(opt => ({
                                value: opt.value || opt.label,
                                label: opt.label
                              }));
                              const selectedOption = processedOptions.find(opt => opt.value === nestedValue);

                              return (
                                <SelectField
                                  key={`${index}-${triggerIndex}`}
                                  label={triggerField.label}
                                  value={selectedOption || null}
                                  options={processedOptions}
                                  onChange={(selectedOption) => {
                                    const updatedCustomFields = [...this.state.customFields];
                                    if (!updatedCustomFields[index].nestedValues) {
                                      updatedCustomFields[index].nestedValues = {};
                                    }
                                    updatedCustomFields[index].nestedValues[triggerField.id] = selectedOption ? selectedOption.value : '';
                                    this.setState({ customFields: updatedCustomFields }, this.validateForm);
                                  }}
                                />
                              );
                            } else {
                              return (
                                <InputField
                                  key={`${index}-${triggerIndex}`}
                                  label={triggerField.label}
                                  value={nestedValue}
                                  onChange={(e) => {
                                    const updatedCustomFields = [...this.state.customFields];
                                    if (!updatedCustomFields[index].nestedValues) {
                                      updatedCustomFields[index].nestedValues = {};
                                    }
                                    updatedCustomFields[index].nestedValues[triggerField.id] = e.target.value;
                                    this.setState({ customFields: updatedCustomFields }, this.validateForm);
                                  }}
                                />
                              );
                            }
                          })}
                        </div>
                      );
                    } else if (field.type === 'sfcontactsearch') {
                      const sfIndex = sfContactSearchIndices.indexOf(index);
                      if (sfIndex >= visibleSfContactSearchCount) return null;

                      const isFirstSfContact = sfIndex === 0;
                      const isLastVisible = sfIndex === visibleSfContactSearchCount - 1;
                      const canRemove = isLastVisible && sfIndex > 0;
                      const canAddMore = visibleSfContactSearchCount < sfContactSearchIndices.length;

                      const fieldContent = (
                        <div style={{ display: 'flex', alignItems: 'center' }}>
                          <div className="w-100" style={{ position: 'relative' }}>
                            <InputField
                              label={field.label}
                              required={field.required}
                              value={this.state.contactSearchValues[index] || ''}
                              onChange={(e) => this.triggerContactSearch(e.target.value, index)}
                            />
                            {!this.state.contactSearching[index] && (
                              <div style={{ position: 'absolute', right: '10px', top: '28px', color: '#999', fontSize: '20px' }}>
                                <i className="las la-search"></i>
                              </div>
                            )}
                            {this.state.contactSearching[index] && (
                              <div style={{ position: 'absolute', right: '10px', top: '35px', color: '#999' }}>
                                <i className="las la-spinner la-spin"></i>
                              </div>
                            )}
                            {this.state.selectedContacts[index] && (
                              <div style={{ position: 'absolute', right: '35px', top: '35px', cursor: 'pointer' }} onClick={() => {
                                this.setState(prevState => ({
                                  selectedContacts: {
                                    ...prevState.selectedContacts,
                                    [index]: null
                                  },
                                  contactSearchValues: {
                                    ...prevState.contactSearchValues,
                                    [index]: ''
                                  },
                                  contactSearchResults: {
                                    ...prevState.contactSearchResults,
                                    [index]: []
                                  }
                                }));
                                const updatedCustomFields = [...this.state.customFields];
                                updatedCustomFields[index].value = '';
                                updatedCustomFields[index].displayValue = '';
                                this.setState({ customFields: updatedCustomFields }, this.validateForm);
                              }}>
                                <i className="las la-times"></i>
                              </div>
                            )}
                            {(this.state.contactSearchResults[index] || []).length > 0 && (
                              <div style={{
                                position: 'absolute',
                                top: '100%',
                                left: 0,
                                right: 0,
                                background: 'white',
                                border: '1px solid #ccc',
                                borderRadius: '4px',
                                maxHeight: '200px',
                                overflowY: 'auto',
                                zIndex: 1000,
                                boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
                              }}>
                                {(this.state.contactSearchResults[index] || []).map((contact, j) => (
                                  <div
                                    key={j}
                                    style={{
                                      padding: '10px',
                                      cursor: 'pointer',
                                      borderBottom: j < (this.state.contactSearchResults[index] || []).length - 1 ? '1px solid #eee' : 'none'
                                    }}
                                    onClick={() => {
                                      const updatedCustomFields = [...this.state.customFields];
                                      //updatedCustomFields[index].value = (contact.FirstName || '') + ' ' + (contact.LastName || '');
                                      updatedCustomFields[index].value = contact.Id;
                                      updatedCustomFields[index].displayValue = (contact.FirstName || '') + ' ' + (contact.LastName || '');

                                      this.setState({ customFields: updatedCustomFields }, this.validateForm);
                                      this.selectContact(contact, index)
                                    }}
                                  >
                                    <div style={{ fontWeight: 'bold' }}>
                                      {contact.FirstName || ''} {contact.LastName || ''}
                                    </div>
                                    <div style={{ fontSize: '12px', color: '#666' }}>
                                      {contact.Email}
                                    </div>
                                    <div style={{ fontSize: '12px', color: '#666' }}>
                                      {contact.MailingCity ? `${contact.MailingCity}${contact.MailingState ? ', ' : ''}` : ''}{contact.MailingState}{contact.MailingPostalCode ? ` ${contact.MailingPostalCode}` : ''}
                                    </div>
                                  </div>
                                ))}
                              </div>
                            )}
                          </div>
                          {canRemove && (
                            <button
                              className="neu ml-10 "
                              style={{ marginTop: '9px' }}
                              onClick={() => {
                                // Clear data for this field
                                this.setState(prevState => ({
                                  selectedContacts: {
                                    ...prevState.selectedContacts,
                                    [index]: null
                                  },
                                  contactSearchValues: {
                                    ...prevState.contactSearchValues,
                                    [index]: ''
                                  },
                                  contactSearchResults: {
                                    ...prevState.contactSearchResults,
                                    [index]: []
                                  },
                                  visibleSfContactSearches: sfIndex
                                }));
                                const updatedCustomFields = [...this.state.customFields];
                                updatedCustomFields[index].value = '';
                                updatedCustomFields[index].displayValue = '';
                                this.setState({ customFields: updatedCustomFields }, this.validateForm);
                              }}
                            >
                              <i className="las la-trash"></i>
                            </button>
                          )}
                        </div>
                      );

                      if (isLastVisible && canAddMore) {
                        return (
                          <>
                            {fieldContent}
                            <button
                              className="neu ml-a mb-20"
                              onClick={() => this.setState({ visibleSfContactSearches: (this.state.visibleSfContactSearches || 1) + 1 })}
                            >
                              Add Another Contact
                            </button>
                          </>
                        );
                      } else {
                        return fieldContent;
                      }


                    } else if (field.type === 'sfaccountsearch') {
                      return (
                        <div className="w-100" style={{ position: 'relative' }}>
                          <InputField
                            label={field.label}
                            required={field.required}
                            value={this.state.accountSearchValues[index] || ''}
                            onChange={(e) => this.triggerAccountSearch(e.target.value, index)}
                          />
                          {!this.state.accountSearching[index] && (
                            <div style={{ position: 'absolute', right: '10px', top: '28px', color: '#999', fontSize: '20px' }}>
                              <i className="las la-search"></i>
                            </div>
                          )}
                          {this.state.accountSearching[index] && (
                            <div style={{ position: 'absolute', right: '10px', top: '35px', color: '#999' }}>
                              <i className="las la-spinner la-spin"></i>
                            </div>
                          )}
                          {this.state.selectedAccounts[index] && (
                            <div style={{ position: 'absolute', right: '35px', top: '35px', cursor: 'pointer' }} onClick={() => {
                              this.setState(prevState => ({
                                selectedAccounts: {
                                  ...prevState.selectedAccounts,
                                  [index]: null
                                },
                                accountSearchValues: {
                                  ...prevState.accountSearchValues,
                                  [index]: ''
                                },
                                accountSearchResults: {
                                  ...prevState.accountSearchResults,
                                  [index]: []
                                }
                              }));
                              const updatedCustomFields = [...this.state.customFields];
                              updatedCustomFields[index].value = '';
                              updatedCustomFields[index].displayValue = '';
                              this.setState({ customFields: updatedCustomFields }, this.validateForm);
                            }}>
                              <i className="las la-times"></i>
                            </div>
                          )}
                          {(this.state.accountSearchResults[index] || []).length > 0 && (
                            <div style={{
                              position: 'absolute',
                              top: '100%',
                              left: 0,
                              right: 0,
                              background: 'white',
                              border: '1px solid #ccc',
                              borderRadius: '4px',
                              maxHeight: '200px',
                              overflowY: 'auto',
                              zIndex: 1000,
                              boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
                            }}>
                              {(this.state.accountSearchResults[index] || []).map((account, i) => (
                                <div
                                  key={i}
                                  style={{
                                    padding: '10px',
                                    cursor: 'pointer',
                                    borderBottom: i < (this.state.accountSearchResults[index] || []).length - 1 ? '1px solid #eee' : 'none'
                                  }}
                                  onClick={() => {
                                    const updatedCustomFields = [...this.state.customFields];
                                    updatedCustomFields[index].value = account.Id;
                                    updatedCustomFields[index].displayValue = account.Name;

                                    this.setState({ customFields: updatedCustomFields }, this.validateForm);
                                    this.selectAccount(account, index)
                                  }}
                                >
                                  <div style={{ fontWeight: 'bold' }}>{account.Name}</div>
                                  <div style={{ fontSize: '12px', color: '#666' }}>
                                    {account.BillingCity ? `${account.BillingCity}${account.BillingState ? ', ' : ''}` : ''}{account.BillingState}{account.BillingPostalCode ? ` ${account.BillingPostalCode}` : ''}
                                  </div>
                                </div>
                              ))}
                            </div>
                          )}
                        </div>
                      );
                    } else if (field.type === 'multiSelectPicklist') {
                      return (
                        <div key={index} style={{ marginBottom: '12px' }}>
                          <div className="formFieldLabel">{field.label || `Field ${index + 1}`}{field.required ? '*' : ''}</div>
                          {field.options && field.options.map((option, optIndex) => {
                            const optionValue = (option.value || option.label).trim();
                            const selectedValues = field.value ? field.value.split(';').map(v => v.trim()).filter(v => v) : [];
                            const isChecked = selectedValues.includes(optionValue);

                            return (
                              <div key={optIndex} style={{ marginBottom: '8px' }}>
                                <label style={{ display: 'flex', alignItems: 'center', cursor: 'pointer' }}>
                                  <input
                                    type="checkbox"
                                    checked={isChecked}
                                    onChange={(e) => {
                                      const updatedCustomFields = [...this.state.customFields];
                                      let currentValues = updatedCustomFields[index].value
                                        ? updatedCustomFields[index].value.split(';').map(v => v.trim()).filter(v => v)
                                        : [];

                                      if (e.target.checked) {
                                        currentValues.push(optionValue);
                                      } else {
                                        currentValues = currentValues.filter(v => v !== optionValue);
                                      }

                                      updatedCustomFields[index].value = currentValues.join(';');
                                      this.setState({ customFields: updatedCustomFields }, this.validateForm);
                                    }}
                                    style={{ marginRight: '8px' }}
                                  />
                                  <span>{option.label}</span>
                                </label>
                              </div>
                            );
                          })}
                        </div>
                      );

                    } else {
                      return (
                        <InputField
                          key={index}
                          label={field.label || `Field ${index + 1}`}
                          required={field.required}
                          value={field.value}
                          onChange={(e) => {
                            const updatedCustomFields = [...this.state.customFields];
                            updatedCustomFields[index].value = e.target.value;
                            this.setState({ customFields: updatedCustomFields }, this.validateForm);
                          }}
                        />
                      );
                    }
                  })}

                </>)
              })()}
            </div>
          )}
        </div>
        <SectionFooter
          editing={editing}
          cancelEdit={this.cancelEdit}
          saveEdit={this.saveRequest}
          updatedAt={program.updatedAt}
        />
      </div>
    );
  }
}

export default withRouter(RequestDetails);
